import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3363c4d1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3363c4d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3363c4d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3363c4d1')) {
      api.createRecord('3363c4d1', component.options)
    } else {
      api.reload('3363c4d1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3363c4d1&scoped=true&", function () {
      api.rerender('3363c4d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/index.vue"
export default component.exports